module.exports = __webpack_public_path__ + "static/media/greenhouse2Step12-8.7a2496cb.jpg";